module.exports = __webpack_public_path__ + "static/images/dbd-678ae186.png";